export {
    TabGroup,
    type IndividualTabPropsCustom,
    type IndividualTabProps,
    type IndividualTabPropsCards,
    type CardNums,
    type DisplayProps,
    type ImageDisplayProps,
    type IndividualTabPropsQuote,
    Quote,
    type TabColorProps,
    type IndividualTabPropsImageFullWidth,
    type TabGroupProps,
    type VideoDisplayProps,
    renderTabContent,
    type TabContentTypes,
    type TabsTypes
} from "./tab-group";
export { TabGroup as default } from "./tab-group";
